import template from './error.html';

class ErrorController {
  constructor() {}
}

export default {
  template,
  controller: ErrorController,
  controllerAs: 'vm'
};
